export const DEFAULT_ICON_URL =
  'https://static.sparemin.com/static/webapp-assets/instagram-default-profile-picture.jpeg';
